import semver from 'semver'
import GameRoleInfo from './GameRoleInfo'

function plugin(app) {
    if (app.DialogsInstalled) {
        return
    }
    app.DialogsInstalled = true



    if (semver.lt(app.version, '3.0.0')) {
        Object.defineProperties(app.prototype, {
            $GameRoleInfo: {
                get: function get() {
                    return GameRoleInfo
                }
            },
            $GameFamilyMember: {
                get: function get() {
                    return FamilyMember
                }
            },
        })
    } else {
        app.config.globalProperties.$GameRoleInfo = GameRoleInfo
    }

}

export default {
    install: plugin
}
window.$GameRoleInfo = GameRoleInfo
export { GameRoleInfo, }